import { createContext } from "react";

const HeaderBgContext = createContext();

export default HeaderBgContext;